var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SubCategoryTable',{ref:"subcategory-table"}),(_vm.openSubcategories)?_c('SubcategoriesModal',{on:{"close":function($event){_vm.openSubcategories = false},"refresh":_vm.refreshTable}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }